<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        @click="showNotification = true"
        :badge="notifications.length"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
        <b-badge pill variant="light-primary">
          {{ notifications.length }} New
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      v-if="showNotification"
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Account Notification :href="notification.data.notification_url" -->
      <b-link v-for="notification in notifications" :key="notification.id">
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :src="notification.avatar"
              :text="notification.avatar"
              :variant="notification.type"
            />
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.data.notification_title }}
            </span>
          </p>
          <small
            @click="
              readNotification(
                notification.id,
                notification.data.notification_url
              )
            "
            class="notification-text"
            v-html="notification.data.notification_body"
          ></small>
        </b-media>
      </b-link>
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        :to="{ name: 'notifications' }"
        block
        @click="markAllAsRead()"
        >Read all notifications</b-button
      >
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import { ref } from "@vue/composition-api";

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showNotification: false,
    };
  },

  setup() {
    /* eslint-disable global-require */
    const notifications = ref([]);
    /* eslint-disable global-require */

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    return {
      notifications,
      perfectScrollbarSettings,
    };
  },
  methods: {
    fetch_ref_data() {
      var _this = this;
      _this.$store
        .dispatch("notification/fetchAllSystemNotification")
        .then((res) => {
          if (res.data) {
            _this.notifications = res.data;
          }
        });
    },

    readNotification(id, url) {
      var _this = this;
      _this.$store.dispatch("notification/readNotification", id).then((res) => {
        if (res.data) {
          _this.fetch_ref_data();
          if (url) {
            _this.$router.push({ path: url });
          }
        }
      });
    },
    markAllAsRead() {
      var _this = this;
      _this.$store
        .dispatch("notification/markAllAsRead")
        .then((res) => {
          _this.fetch_ref_data();
        });
    },
  },
  created() {
    var _this = this;
    _this.fetch_ref_data();
  },
};
</script>

<style>
</style>
